var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPyCharm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4864 5.67578L31.5893 13.2067L28.2625 19.8967L22.8154 18.3613H18.0264L22.4864 5.67578Z",
    fill: "url(#paint0_linear_1320_7641)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.274 10.5743L11.5192 19.8965L11.373 23.1136L6.87637 25.0146L0.625 25.6727L2.526 5.52931L13.9686 0.740234L20.9511 5.38308L13.274 10.5743Z",
    fill: "url(#paint1_linear_1320_7641)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.274 10.5742L14.1513 28.5607L11.2633 31.924L0.625 25.6726L9.36229 12.5849L13.274 10.5742Z",
    fill: "url(#paint2_linear_1320_7641)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0448 9.25823H14.2603L23.8018 0.740234L25.0448 9.25823Z",
    fill: "url(#paint3_linear_1320_7641)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7726 28.5975L22.2676 31.8511L9.61865 28.305L13.2744 10.5746L14.7367 9.2585L22.487 8.52734L21.7558 16.2776L27.8975 13.9013L31.7726 28.5975Z",
    fill: "url(#paint4_linear_1320_7641)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9232 6.58887H6.43799V26.0741H25.9232V6.58887Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30163 22.4196H15.6132V23.626H8.30163V22.4196ZM8.22852 9.1126H11.5553C13.4928 9.1126 14.6261 10.2459 14.6261 11.891C14.6261 13.7554 13.1638 14.7059 11.3725 14.7059H9.98328V17.1553H8.22852V9.1126ZM12.7982 12.0007C12.7982 11.233 12.2499 10.7943 11.3359 10.7943H9.98328V13.2802H11.409C12.3961 13.2436 12.8348 12.6953 12.7982 12.0007ZM15.3207 13.2071C15.3039 12.1184 15.7164 11.0669 16.469 10.2801C17.2216 9.49334 18.2537 9.03451 19.342 9.00293H19.5248C21.0237 9.00293 21.9742 9.47818 22.7054 10.2825L21.5721 11.5985C21.0365 11.0364 20.3009 10.708 19.5248 10.6846C18.1722 10.6846 17.1851 11.8179 17.1851 13.2071C17.1851 14.5963 18.1722 15.7296 19.5248 15.7296C20.4388 15.7296 21.0237 15.3274 21.6817 14.8156L22.815 15.9489C22.0926 16.8068 21.059 17.3427 19.9416 17.4387C18.8241 17.5347 17.7143 17.1829 16.8561 16.4607C16.3628 16.077 15.9667 15.5825 15.6999 15.0172C15.4332 14.452 15.3033 13.8319 15.3207 13.2071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1320_7641",
    x1: 11.6566,
    y1: 12.5918,
    x2: 30.3565,
    y2: 12.5918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1320_7641",
    x1: -10.0148,
    y1: 27.2344,
    x2: 31.6793,
    y2: 6.37169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A7EB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5FE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#32DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#20D68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1ED497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19D1A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#13CCC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0BC6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1320_7641",
    x1: 4.83645,
    y1: 35.1667,
    x2: 16.6509,
    y2: 19.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#24D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2FD886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#41DA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5ADC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7AE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A1E36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#CFE865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1320_7641",
    x1: 13.2001,
    y1: 17.981,
    x2: 22.5533,
    y2: -2.64188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#24D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2FD886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#41DA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5ADD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#79E077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7CE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CE173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B2E56B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1320_7641",
    x1: 34.1123,
    y1: 20.1636,
    x2: 6.83137,
    y2: 19.5316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECF451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C2E964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B2E56B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyCharm);
export default __webpack_public_path__ + "static/media/pyCharm.bf135f9fe27033c2b7715c96ae43c229.svg";
export { ForwardRef as ReactComponent };